import { render, staticRenderFns } from "./IVF.vue?vue&type=template&id=3e4b921a&scoped=true"
import script from "./IVF.vue?vue&type=script&lang=js"
export * from "./IVF.vue?vue&type=script&lang=js"
import style0 from "./IVF.vue?vue&type=style&index=0&id=3e4b921a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4b921a",
  null
  
)

export default component.exports